import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.widget.all.weight');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-component-widget-all-weight',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.widget.all.weight/view.scss */
/* src/app/component.widget.all.weight/view.scss: no such file or directory */`],
})
export class ComponentWidgetAllWeightComponent implements OnInit {
    @Input() value: number | null = null;

    public async ngOnInit() {
    }
}

export default ComponentWidgetAllWeightComponent;